import { LocaleFilterPipe } from '@pipes/locale-filter.pipe';
import { I18nString } from '@models/i18n/i18n-string';
import { PermissionSet } from './permission/permission-set';
import { I18nStringMap } from './i18n/i18n-string-map';

export type RoleType = 'ADMIN' | 'B2B' | 'SYSTEM';



export class Role {
    roleId: string;
    roleCode: string;
    type: RoleType;
    // roleName: string;
    roleName: I18nStringMap;
    remarks: string;
    permissionSets: PermissionSet[] = [];


    constructor() {
        this.roleName = new I18nStringMap();
        let en = new I18nString();
        let zh_tw = new I18nString();
        let zh_cn = new I18nString();
        en.locale = 'en';
        zh_tw.locale = 'zh_TW';
        zh_cn.locale = 'zh_CN';

        this.roleName.i18nStrings = [];
        this.roleName.i18nStrings.push(en);
        this.roleName.i18nStrings.push(zh_tw);
        this.roleName.i18nStrings.push(zh_cn);
    }

    static search(term: string, item: Role) {
        term = term.toLocaleLowerCase();
        return item.roleName.i18nStrings.findIndex(name => name.value.toLocaleLowerCase().indexOf(term) > -1) > -1;
    }
}

export class RoleSearchingCriteria {
    code: string;
    name: string;
}
